// extracted by mini-css-extract-plugin
export default {"bottomSheet":"kI6v7","wrap":"Vctnh","backdrop":"ZnOQH","animated":"K4aY_","handle":"XfGAO","line":"DRxeV","body":"u7NQ7","expanded":"xuoYY"};